import { WithRef } from '../../../types';
import IconBase, { getStrokeWidth, IconProps } from '../IconBase';

export const CastHorizontalLinkDash = ({
  ref,
  color = 'currentColor',
  ...props
}: WithRef<SVGSVGElement, IconProps>) => {
  const strokeWidth = props.strokeWidth ?? getStrokeWidth(props.weight);

  return (
    <IconBase ref={ref} {...props} viewBox="0 0 32 32" fill="none">
      <path
        d="M19.9948 10.574L23.1633 10.574C24.4453 10.6395 25.6552 11.2476 26.5415 12.2718C27.4278 13.2961 27.9224 14.6578 27.9224 16.0739C27.9224 17.49 27.4278 18.8517 26.5415 19.8759C25.6552 20.9002 24.4453 21.5083 23.1633 21.5738L18.6426 21.565C17.9887 21.5663 17.3411 21.4252 16.7367 21.1497C16.1323 20.8743 15.5832 20.4698 15.1209 19.9597C14.6585 19.4495 14.292 18.8436 14.0423 18.1768C13.7926 17.51 13.6647 16.7954 13.666 16.0739M11.8499 21.574H8.68147C7.39938 21.5084 6.18948 20.9004 5.30319 19.8761C4.41689 18.8519 3.92236 17.4902 3.92236 16.0741C3.92236 14.6579 4.41689 13.2963 5.30319 12.272C6.18948 11.2478 7.39938 10.6397 8.68147 10.5742L13.2021 10.583C13.856 10.5816 14.5037 10.7227 15.108 10.9982C15.7124 11.2737 16.2615 11.6781 16.7239 12.1883C17.1862 12.6984 17.5528 13.3043 17.8024 13.9711C18.0521 14.6379 18.18 15.3526 18.1788 16.0741"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6274 5L5.00002 27.6274"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </IconBase>
  );
};

CastHorizontalLinkDash.displayName = 'CastHorizontalLinkDash';
